import React from "react";
import { JsonEditor } from 'json-edit-react'

function JsonInput({jsonData, setJsonData}) {
    return <JsonEditor
        data={ jsonData }
        setData={ setJsonData }
    />
}

export default JsonInput;